<app-shared-navbar
  [brandRoute]="'/reportlibrary/editreport/process'"
  [siteName]="sitename"
  [menuItems]="menuItems"
  [profileMenuItems]="profileMenuItems"
  [avatarSrc]="avatarSrc"
  [showNotifications]="notificationConfig.show"
  [notificationPermission]="notificationConfig.permission"
  (itemSelected)="onNavbarAction($event)">
</app-shared-navbar>

